import { createFileRoute } from '@tanstack/react-router';

import { BrazilChoropleth } from '~/components/analytics/BrazilChoropleth.js';
import { FiltrosBar } from '~/components/analytics/FiltrosBar.js';
import { TopList } from '~/components/analytics/TopList.js';
import { useBreakdown } from '~/features/analytics/hooks.js';
import { analyticsSearchSchema, searchToPeriod } from '~/features/analytics/useFiltros.js';
import { downloadCsv } from '~/lib/csv.js';

export const Route = createFileRoute('/_auth/analytics/geografia')({
  validateSearch: (search) => analyticsSearchSchema.parse(search),
  component: AnalyticsGeografia,
});

function AnalyticsGeografia() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const period = searchToPeriod(search);
  const setRange = (range: '7d' | '30d' | '90d') =>
    void navigate({ search: { ...search, range, from: undefined, to: undefined } });
  const toggleComparar = () => void navigate({ search: { ...search, comparar: !period.comparar } });
  const ufs = useBreakdown(period, 'uf', 27);
  const cities = useBreakdown(period, 'city', 15);

  const ufMap: Record<string, number> = {};
  for (const item of ufs.data?.items ?? []) {
    ufMap[item.key] = item.visitors;
  }

  function handleExport() {
    if (!ufs.data) return;
    downloadCsv(`analytics-uf-${period.range}`, ufs.data.items, [
      { key: 'key', label: 'UF' },
      { key: 'name', label: 'Estado' },
      { key: 'visitors', label: 'Visitantes' },
    ]);
  }

  return (
    <div className="analytics-page">
      <FiltrosBar
        period={period}
        onRangeChange={setRange}
        onToggleComparar={toggleComparar}
        onExportCsv={handleExport}
      />

      <section className="analytics-block">
        <header className="analytics-block__head">
          <h2 className="analytics-block__title">Visitantes por UF</h2>
        </header>
        <BrazilChoropleth data={ufMap} />
      </section>

      <section className="analytics-grid-2">
        <TopList title="Top estados" items={ufs.data?.items.slice(0, 12) ?? []} />
        <TopList title="Top cidades" items={cities.data?.items ?? []} />
      </section>
    </div>
  );
}
